// extracted by mini-css-extract-plugin
export default {"resources":"Resources_resources__J8U07","resources__title":"Resources_resources__title__M9dUN","resources__items":"Resources_resources__items__1tSuF"};